import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=386fd62a&lang=pug"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./AppBreadcrumbs.vue?vue&type=style&index=0&id=386fd62a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports